"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const commonCode_1 = require("@configs/commonCode");
const Icon_1 = __importDefault(require("@modules/Icon"));
const Label_1 = __importDefault(require("@modules/Label"));
const arrayUtils_1 = require("@utils/arrayUtils");
const objectUtils_1 = __importDefault(require("@utils/objectUtils"));
const react_1 = __importDefault(require("react"));
require("./style.scss");
const SearchableDropDown = (props) => {
    var _a, _b, _c, _d;
    const { disabled = false, readonly = false, label, name, customOptions, required = false, hideDefault = false, defaultValue, onChange, onBlur, onClick, message, register, messages, validate, dataIndex, isShowIntervalMark = false } = props;
    /**
     * 轉換選項的 id 及 name
     * @param IdOrName 轉換對象 （選項的 id 或 name)
     * @param currentKey 目前傳入轉換對象的 key (字串 key id 或 name)
     * @returns
     */
    const convertIdAndName = (IdOrName, currentKey) => {
        const convertedKey = currentKey === 'id' ? 'name' : 'id';
        const targetOption = !objectUtils_1.default.isExist(IdOrName) ? [fixedOptions.current.default] : customOptions;
        const matchedOption = targetOption.find((option) => {
            return option[currentKey] === IdOrName;
        });
        if (!objectUtils_1.default.isExist(matchedOption))
            return '';
        return matchedOption[convertedKey];
    };
    const fixedOptions = react_1.default.useRef({
        noResult: { name: '無資料', id: 'none' },
        default: { name: '請選擇', id: 'default-value' }
    });
    const [filteredOptions, setFilteredOptions] = react_1.default.useState(customOptions);
    const [isOptionsShow, setIsOptionsShow] = react_1.default.useState(false);
    const [inputValue, setInputValue] = react_1.default.useState(defaultValue ? convertIdAndName(defaultValue, 'id') : fixedOptions.current.default.name);
    const isFirstRender = react_1.default.useRef(true);
    const inputElement = react_1.default.useRef(null);
    const searchableDropDownElement = react_1.default.useRef(null);
    const optionsElement = react_1.default.useRef(null);
    const [parentNodes, setParentNodes] = react_1.default.useState([]);
    const [previousOptionName, setPreviousOptionName] = react_1.default.useState(inputValue);
    /**
     * 處理點選選項列表展開
     */
    const handleClickOptionsExpand = () => {
        if (disabled || readonly)
            return setIsOptionsShow(false);
        setIsOptionsShow(!isOptionsShow);
        handleResetFilteredOptions();
        if (inputValue === fixedOptions.current.default.name)
            setInputValue('');
    };
    /**
     * 處理選項由點選選項清單改變
     * @param event
     * @returns
     */
    const handleOptionSelect = (event) => {
        const targetOptionId = event.target.getAttribute('id');
        const targetOptionName = event.target.getAttribute('data-name');
        if (readonly || disabled)
            return;
        const returnValue = targetOptionId === fixedOptions.current.default.id ? '' : targetOptionId;
        if (onChange)
            onChange({ name, value: returnValue });
        setInputValue(targetOptionName);
        setPreviousOptionName(targetOptionName);
        setIsOptionsShow(false);
    };
    /**
     * 處理選項由使用者輸入而改變
     * @param event
     */
    const handleOnChange = (event) => {
        const targetValue = event.target.value;
        if (readonly || disabled)
            return;
        setInputValue(targetValue);
    };
    const handleOnBlur = (event) => {
        if (readonly || disabled)
            return;
        if (onBlur)
            onBlur(event);
        if (inputValue === fixedOptions.current.default.name || inputValue === '') {
            if (onChange)
                onChange({ name, value: '' });
            setInputValue(previousOptionName);
        }
        else {
            const matchedOption = customOptions.find((option) => {
                return option.name === inputValue;
            });
            if (!objectUtils_1.default.isExist(matchedOption)) {
                const returnValue = convertIdAndName(previousOptionName, 'name');
                if (onChange)
                    onChange({ name, value: returnValue });
                setInputValue(previousOptionName);
            }
        }
        setIsOptionsShow(false);
    };
    /**
     * 處理點選 input 範圍
     */
    const handleClickInput = (event) => {
        if (objectUtils_1.default.isExist(onClick))
            onClick(event);
        if (disabled || readonly)
            return setIsOptionsShow(false);
        setIsOptionsShow(true);
        handleResetFilteredOptions();
        if (inputValue === fixedOptions.current.default.name)
            setInputValue('');
    };
    /**
     * 處理點選展開選項時重置篩選選項為全部
     */
    const handleResetFilteredOptions = () => {
        const customOptionNames = customOptions.map((item) => item.name);
        if (customOptionNames.includes(inputValue))
            setFilteredOptions(customOptions);
    };
    /**
     * 處理選項過濾
     * @returns
     */
    const handleFilterOptions = () => {
        const filteredOptions = customOptions.filter((item) => {
            var _a;
            return (_a = item.name) === null || _a === void 0 ? void 0 : _a.includes(inputValue);
        });
        if ((0, arrayUtils_1.isEmptyArray)(filteredOptions))
            return setFilteredOptions([fixedOptions.current.noResult]);
        setFilteredOptions(filteredOptions);
        handleResetFilteredOptions();
    };
    const isNoMatch = filteredOptions.length === 1 && filteredOptions[0].id === fixedOptions.current.noResult.id;
    const isDefaultOptionShow = hideDefault ? false : !(isNoMatch || filteredOptions.length !== customOptions.length);
    /**
     * 取得 input 的座標及元素寬度
     * @returns
     */
    const getInputCoordinationAndWidth = () => {
        if (!inputElement.current)
            return;
        const inputBoundingClientRect = inputElement.current.getBoundingClientRect();
        return {
            top: inputBoundingClientRect.top + inputBoundingClientRect.height,
            left: inputBoundingClientRect.left,
            width: inputBoundingClientRect.width
        };
    };
    /**
     * 處理點擊下拉選單外圍
     * @param event
     */
    const handleClickOutside = (event) => {
        const target = event.target;
        if (searchableDropDownElement.current && !searchableDropDownElement.current.contains(target))
            setIsOptionsShow(false);
    };
    /**
     * 處理滑鼠滾動
     */
    const handleScroll = () => {
        setIsOptionsShow(false);
    };
    const handleKeyDown = (event) => {
        if (event.key === commonCode_1.commonCode.KEY.escape)
            setIsOptionsShow(false);
    };
    /**
     * 取得目前 component parentNode array
     * @returns
     */
    const getParentNodes = () => {
        const mainContentWrapper = document.querySelector('.main__content');
        const modalContentWrapper = document.querySelector('.modal__wrapper .board__content');
        const modalTableScroll = document.querySelector('.modal__wrapper .table__scroll');
        const parentNodesArray = [];
        if (objectUtils_1.default.isExist(modalTableScroll)) {
            if (modalTableScroll.contains(searchableDropDownElement.current))
                parentNodesArray.push(modalTableScroll);
        }
        if (objectUtils_1.default.isExist(modalContentWrapper)) {
            if (modalContentWrapper.contains(searchableDropDownElement.current))
                parentNodesArray.push(modalContentWrapper);
        }
        if (objectUtils_1.default.isExist(mainContentWrapper)) {
            if (mainContentWrapper.contains(searchableDropDownElement.current))
                parentNodesArray.push(mainContentWrapper);
        }
        return parentNodesArray;
    };
    // 處理無 register 時候的 onblur handler binding
    const getOnBlurHandler = () => {
        if (objectUtils_1.default.isExist(register))
            return null;
        return { onBlur: handleOnBlur };
    };
    const getRegisterRefAndRest = () => {
        var _a;
        if (!register || !objectUtils_1.default.isExist(register))
            return null;
        const requiredField = required && { required: (_a = messages === null || messages === void 0 ? void 0 : messages.required) !== null && _a !== void 0 ? _a : '' };
        const validateField = objectUtils_1.default.isExist(validate) && { validate };
        const _b = register(name, Object.assign(Object.assign({}, requiredField), validateField)), { ref: registerRef } = _b, rest = __rest(_b, ["ref"]);
        return {
            registerRef,
            rest: Object.assign(Object.assign({}, rest), { onBlur: (event) => {
                    rest.onBlur(event);
                    handleOnBlur(event);
                } })
        };
    };
    const handleOptionsMouseDown = (event) => event.preventDefault();
    const getOptionListMaxHeight = () => {
        if (!objectUtils_1.default.isExist(inputElement.current))
            return;
        if (!inputElement.current)
            return;
        const bufferDistanceToEdge = 5;
        const viewPortHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const referenceBoundingClientRect = inputElement.current.getBoundingClientRect();
        const optionListMaxHeight = viewPortHeight - (referenceBoundingClientRect === null || referenceBoundingClientRect === void 0 ? void 0 : referenceBoundingClientRect.bottom) - bufferDistanceToEdge;
        return optionListMaxHeight;
    };
    react_1.default.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (inputValue !== fixedOptions.current.default.name)
            handleFilterOptions();
    }, [inputValue]);
    react_1.default.useEffect(() => {
        if ((0, arrayUtils_1.isEmptyArray)(parentNodes))
            return;
        parentNodes.forEach((parentNode) => {
            parentNode.addEventListener('scroll', handleScroll);
            parentNode.addEventListener('click', handleClickOutside);
        });
        return () => {
            parentNodes.forEach((parentNode) => {
                if (!parentNode)
                    return;
                parentNode.removeEventListener('scroll', handleScroll);
                parentNode.removeEventListener('click', handleClickOutside);
            });
        };
    }, [parentNodes]);
    // 當選項改變時，將由新的 customOptions 當中找到相對應的選項設定在 inputValue值
    react_1.default.useLayoutEffect(() => {
        setFilteredOptions(customOptions);
        setInputValue(defaultValue ? convertIdAndName(defaultValue, 'id') : fixedOptions.current.default.name);
    }, [customOptions]);
    // 當 defaultValue 改變，判斷目前是否 input 是否 focus （代表正在輸入），若不是才 setInputValue，避免在輸入清空時回復成請選擇
    react_1.default.useEffect(() => {
        if (inputElement.current !== document.activeElement) {
            const newDisplayValue = defaultValue
                ? convertIdAndName(defaultValue, 'id')
                : fixedOptions.current.default.name;
            setInputValue(newDisplayValue);
            setPreviousOptionName(newDisplayValue);
        }
    }, [defaultValue]);
    react_1.default.useEffect(() => {
        const parentNodesArray = getParentNodes();
        setParentNodes(parentNodesArray);
    }, []);
    // 點選選單區塊時時取消 input 區塊預設 onBlur 行為
    react_1.default.useEffect(() => {
        if (!optionsElement.current)
            return;
        if (!inputElement.current)
            return;
        if (isOptionsShow)
            optionsElement.current.addEventListener('mousedown', handleOptionsMouseDown);
        if (!isOptionsShow)
            inputElement.current.blur();
        return () => {
            var _a;
            (_a = optionsElement.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousedown', handleOptionsMouseDown);
        };
    }, [isOptionsShow]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `searchableDropDown__wrapper ${required && 'required'} ${objectUtils_1.default.isExist(message) && 'errorInput'}`, ref: searchableDropDownElement, onKeyDown: handleKeyDown }, { children: [(0, jsx_runtime_1.jsx)(Label_1.default, Object.assign({ htmlFor: name, className: "label" }, { children: label })), (0, jsx_runtime_1.jsx)("input", Object.assign({}, (_a = getRegisterRefAndRest()) === null || _a === void 0 ? void 0 : _a.rest, { autoComplete: "off", disabled: disabled, name: name, className: `${readonly && 'readonly'}`, value: inputValue, onChange: handleOnChange, onClick: handleClickInput, id: name, "data-index": dataIndex, ref: (element) => {
                    var _a;
                    inputElement.current = element;
                    (_a = getRegisterRefAndRest()) === null || _a === void 0 ? void 0 : _a.registerRef(element);
                } }, getOnBlurHandler())), (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: "expand", className: "arrowDown", onClick: !readonly && handleClickOptionsExpand }), isOptionsShow && ((0, jsx_runtime_1.jsx)("ul", Object.assign({ id: "options", ref: optionsElement, className: ` ${isNoMatch && 'noMatch'} searchableDropDown__options`, onMouseUp: handleOptionSelect, style: {
                    top: (_b = getInputCoordinationAndWidth()) === null || _b === void 0 ? void 0 : _b.top,
                    left: (_c = getInputCoordinationAndWidth()) === null || _c === void 0 ? void 0 : _c.left,
                    width: (_d = getInputCoordinationAndWidth()) === null || _d === void 0 ? void 0 : _d.width,
                    maxHeight: getOptionListMaxHeight()
                } }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isDefaultOptionShow && ((0, jsx_runtime_1.jsx)("li", Object.assign({ id: fixedOptions.current.default.id, "data-name": fixedOptions.current.default.name, className: `${inputValue === fixedOptions.current.default.name} && 'previousSelect option` }, { children: fixedOptions.current.default.name }), fixedOptions.current.default.id)), filteredOptions.map((item) => {
                            return ((0, jsx_runtime_1.jsx)("li", Object.assign({ id: item.id, "data-name": item.name, className: `${inputValue === item.name && 'previousSelect'} option` }, { children: item.name }), item.id));
                        })] }) }))), isShowIntervalMark && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "intervalMark" }, { children: "~" })), objectUtils_1.default.isExist(message) && (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "errorMessage" }, { children: message }))] })));
};
exports.default = SearchableDropDown;
